import { compose } from "recompose";
import { parse } from "query-string";
import { withRouter } from "react-router-dom";
import { fetchApi } from "core/api/hoc";
import * as api from "modules/payment/api";
import View from "./View";

export default compose(
  withRouter,
  fetchApi(api.createInsiderPaymentInfo, ({ location }) => {
    const { code } = parse(location.search);

    return {
      payload: {
        code
      }
    };
  })
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Insider/PaymentCallback/Provider.js